(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    function loadComplementaryProducts() {
      var section = document.querySelector('.product-complementary');
      if (!section) return;

      var complementaryUrl = section.dataset.complementaryUrl;
      var complementaryBlock = section.querySelector('[data-complementary]');
      var currentProductId = section.dataset.productId;

      fetch(complementaryUrl)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshBlock = doc.querySelector('[data-complementary]');
          if (!freshBlock) return;

          // Check if block actually contains product cards
          var products = freshBlock.querySelectorAll('[data-product-id]');
          if (products.length === 0) return;

          complementaryBlock.innerHTML = freshBlock.innerHTML;

          // Remove self-reference (if product was assigned as its own complementary)
          var selfRef = complementaryBlock.querySelector('[data-product-id="' + currentProductId + '"]');
          if (selfRef) selfRef.remove();

          // Only show block if products remain after self-filter
          var remaining = complementaryBlock.querySelectorAll('[data-product-id]');
          if (remaining.length > 0) {
            complementaryBlock.classList.add('is-visible');
          }
        })
        .catch(function() {
          // Silently fail — no complementary products is fine
        });
    }

    loadComplementaryProducts();

    // Reload when section is re-rendered in the theme editor
    document.addEventListener('shopify:section:load', function(event) {
      if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-complementary')) {
        loadComplementaryProducts();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  let related_flkty = null;
  function initializeFlickityRelated() {
    const elem = document.querySelector('.related-products-wrapper');

    if (!related_flkty) {
      related_flkty = new Flickity(elem, {
        percentPosition: false,
        pageDots: false,
        wrapAround: true,
        watchCSS: true,
        autoPlay: true
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    
  });

  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'related-products'
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      }
      initializeFlickityRelated();
    };

    request.send();

  };
  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();

    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
